import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";

import { ProductsPage } from "./Products";
import { LinksPage } from "./Links";
import { SamplesPage } from "./Samples";
import { CreateLink } from "./CreateLInk";
import { LayoutSplashScreen, ContentRoute } from "../../../_metronic/layout";

import { URLs } from "../../../utils/routes";

export function ServicesPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Redirect exact from={URLs.SERVICES} to={URLs.SERVICES_PRODUCTS} />
        <ContentRoute path={URLs.SERVICES_PRODUCTS} component={ProductsPage} />
        <ContentRoute path={URLs.SERVICES_LINKS_CREATE} component={CreateLink} />
        <ContentRoute path={URLs.SERVICES_LINKS} component={LinksPage} />
        <ContentRoute path={URLs.SERVICES_SAMPLES} component={SamplesPage} />
      </Switch>
    </Suspense>
  );
}
